<template>
  <div>
    <!-- Título principal -->
    <h1 class="titulo-kpi">Kpi Admin</h1>

    <div v-if="!cargar" class="dashboard">
    <div class="card cambios">
      <h2>Cambios</h2>
      <p class="number">{{ totalCambios }}</p>
      <span class="label">Cambios faltantes</span>
      <RouterLink class="btn" to="/miscambios">Ir a vista</RouterLink>
    </div>

  <div class="card tickets">
    <h2>Tickets</h2>
    <p class="number">{{ ticketsPorAsignar }}</p>
    <span class="label">Tickets por asignar</span>
    <RouterLink class="btn" to="/tickets">Ir a vista</RouterLink>
  </div>

  <div class="card facturas">
    <h2>Facturas</h2>
    <p class="number">{{ factuasPendientes }}</p>
    <span class="label">Facturas pendientes</span>
    <RouterLink class="btn" to="/facturassolicitadas">Ir a vista</RouterLink>
  </div>
    </div>

    <carga                v-if="cargar"/>

  </div>
</template>

<script>
import carga                 from '../../components/alertas/carga.vue';
export default {

  components:{
    carga
  },
  data: () => ({
    totalCambios: undefined,
    ticketsPorAsignar: 0,
    factuasPendientes: undefined,
    cargar: true,
  }),
  async mounted() {
    this.carga = true

    try {
      const resCambios = await this.$http.get('cambios.usuario.contador')
      this.totalCambios = resCambios.data.filter(d => d.estatus === 1).length

      const responseTickets = await this.$http.get('tickets.reporte.usuario')
      const listaFiltrada = responseTickets.data.filter(el => el.nombre_completo !== "Total" && ( el.Asignados > 0 || el.Pendiente > 0 || el.Revisión > 0 || el.Rechazados > 0 ) )

      listaFiltrada.map(d => {
        this.ticketsPorAsignar += +d.Asignados + +d.Pendiente + +d.Revisión + +d.Rechazados

      })

    const res = await this.$http.get('facturas.solicitadas')
    this.factuasPendientes = res.data.filter(el =>(!el.xml || !el.pdf) && el.aceptada != 2).length
    } catch (e) {
      console.error('Error al cargar datos:', e)
    } finally {
      this.cargar = false;
  }
}

}

</script>

<style scoped>

.titulo-kpi {
  margin-top: 2rem;
  font-size: 2rem;
  font-weight: 600;
  color: #374151; /* parecido a Tailwind text-gray-700 */
  margin-bottom: 1.5rem;
  text-align: center;
}

.btn {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  width: fit-content;
  background-color: #007BFF;
  border-radius: 8px;
  color: white;
  text-decoration: none;
  align-self: center;
  margin-top: 0.7rem;
}
/* Contenedor principal */
.dashboard {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  margin: 40px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Tarjeta individual */
.card {
  display: flex;
  flex-direction: column;
  flex: 1 1 250px;
  max-width: 300px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  padding: 20px;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.15);
}

/* Título de la tarjeta */
.card h2 {
  font-size: 1.2rem;
  color: #4B5563; /* color parecido a Tailwind text-gray-600 */
  margin-bottom: 10px;
}

/* Número destacado */
.number {
  font-size: 2.5rem;
  font-weight: bold;
  color: #007BFF; /* azul llamativo */
  margin-bottom: 5px;
}

/* Etiqueta descriptiva */
.label {
  font-size: 0.9rem;
  color: #666;
}

/* Colores opcionales por tipo */
.cambios .number { color: #FF6B6B; }   /* rojo */
.tickets .number { color: #FFA500; }   /* naranja */
.facturas .number { color: #28A745; }  /* verde */

</style>
